export default __webpack_public_path__ + "static/media/Vector.7d02ee45.svg";